import {GetRefundOdonto} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetRefundOdonto} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';

export const makeGetRefundOdonto = (): GetRefundOdonto =>
	new RemoteGetRefundOdonto(
		makeBFFApiUrl(ExternalLinkPoint.refundOdonto),
		makeAuthorizeHttpClientDecorator(),
	);
